import { render } from "./Speaker.vue?vue&type=template&id=50cb6d90"
import script from "./Speaker.vue?vue&type=script&lang=js"
export * from "./Speaker.vue?vue&type=script&lang=js"

import "./Speaker.vue?vue&type=style&index=0&id=50cb6d90&lang=css"
script.render = render

export default script